export const baseUrl = process.env.REACT_APP_SHELL_ANALYTICS_SERVICE_BASE_URL;
export const authUrl = process.env.AUTH_URL;

export const OAUTH = {
  CLIENT_ID: "srl-analytics",
  CLIENT_SECRET: "P@ssw0rd",
  GRANT_TYPE: "authorization_code",
  AUTH_URL: process.env.REACT_APP_AUTH_URL,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URL,
};
